import { useEffect, useState } from 'react';
import { Check, Loader2, Printer } from 'lucide-react';
import { api, errorMessage } from '../lib/api';

/* The login has no label printer in Odoo, so the labels of this note did not
   print (the orders are received). Pick one here: it goes on the person's own
   Odoo user, and the next labels come out there. */
export default function PickPrinter() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(null);
  const [saved, setSaved] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.labelPrinters().then(setData).catch((err) => setError(errorMessage(err)));
  }, []);

  const pick = async (p) => {
    setBusy(p.id);
    setError(null);
    try {
      setSaved(await api.setLabelPrinter(p.id));
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(null);
    }
  };

  if (saved) {
    return (
      <p className="tone-out mt-3 flex items-start gap-2 rounded-xl bg-tone-bg px-3 py-2 text-[14px]">
        <Check className="mt-0.5 h-4 w-4 shrink-0 text-tone" />
        <span>
          Your next labels print on <span className="font-semibold">{saved.name}</span>. The labels of this note were not printed: print them from Odoo.
        </span>
      </p>
    );
  }
  const printers = data?.printers?.filter((p) => p.online) || [];
  return (
    <section className="mt-3 rounded-xl bg-sunken px-3 py-3">
      <h3 className="flex items-center gap-1.5 text-[14px] font-semibold">
        <Printer className="h-4 w-4" /> No label printer on your Odoo user
      </h3>
      <p className="mt-0.5 text-[13px] text-ink2">The order is received, but the labels did not print. Pick the printer next to you for next time.</p>
      {!data && !error && (
        <p className="mt-2 flex items-center gap-2 text-[13px] text-ink2">
          <Loader2 className="h-4 w-4 animate-spin" /> Looking for printers…
        </p>
      )}
      {data && !data.can_set && <p className="mt-2 text-[13px] text-ink2">Sign in with your Odoo login to choose one.</p>}
      {data?.can_set && printers.length === 0 && <p className="mt-2 text-[13px] text-ink2">No label printer is online right now.</p>}
      {data?.can_set && printers.length > 0 && (
        <ul className="mt-2 max-h-[40vh] space-y-1.5 overflow-y-auto">
          {printers.map((p) => (
            <li key={p.id}>
              <button type="button" disabled={busy != null} onClick={() => pick(p)} className="flex w-full items-center justify-between gap-2 rounded-lg bg-surface px-3 py-2 text-left active:opacity-80 disabled:opacity-50">
                <span className="min-w-0">
                  <span className="block truncate text-[14px] font-semibold">{p.name}</span>
                  <span className="block truncate text-[12px] text-ink2">
                    {p.computer}
                    {p.used_by.length > 0 && ` · used by ${p.used_by.slice(0, 2).join(', ')}${p.used_by.length > 2 ? ` +${p.used_by.length - 2}` : ''}`}
                  </span>
                </span>
                {busy === p.id && <Loader2 className="h-4 w-4 shrink-0 animate-spin" />}
              </button>
            </li>
          ))}
        </ul>
      )}
      {error && <p className="mt-2 text-[13px] text-alert">{error}</p>}
    </section>
  );
}
